import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { countsToRows, formatNumber, humaniseCode } from "./d2cFormat";

const FILL = {
  blue: "tw-bg-primary",
  grey: "tw-bg-slate-400",
  amber: "tw-bg-amber-500",
  red: "tw-bg-red-500",
};

// A titled list of reason -> count with plain CSS bars, biggest first.
const BarList = ({ title, counts, hint, tone = "blue", emptyText = "None in this range." }) => {
  const rows = countsToRows(counts);
  const max = Math.max(0, ...rows.map((row) => row.count));
  const total = rows.reduce((sum, row) => sum + row.count, 0);

  return (
    <Card>
      <CardHeader>
        <div className="tw-min-w-0">
          <CardTitle>{title}</CardTitle>
          {hint && <CardDescription>{hint}</CardDescription>}
        </div>
        <span className="tw-text-sm tw-font-semibold tw-tabular-nums tw-text-foreground">{formatNumber(total)}</span>
      </CardHeader>
      <CardContent>
        {total === 0 ? (
          <div className="tw-text-sm tw-text-muted-foreground">{emptyText}</div>
        ) : (
          <ul className="tw-m-0 tw-list-none tw-space-y-1.5 tw-p-0">
            {rows.map((row) => (
              <li key={row.code} title={row.code} className="tw-relative tw-flex tw-items-center tw-justify-between tw-gap-2 tw-overflow-hidden tw-rounded-md tw-px-2 tw-py-1 tw-text-sm">
                <span
                  aria-hidden="true"
                  className={`tw-absolute tw-inset-y-0 tw-left-0 tw-rounded-md tw-opacity-15 ${FILL[tone] || FILL.blue}`}
                  style={{ width: max ? `${(row.count / max) * 100}%` : 0 }}
                />
                <span className="tw-relative tw-truncate tw-text-foreground">{humaniseCode(row.code)}</span>
                <span className="tw-relative tw-font-medium tw-tabular-nums">{formatNumber(row.count)}</span>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};

export default BarList;
